import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Enterprise} from '../../../model/Enterprise';
import {EnterpriseService} from '../../../service/enterprise.service';
import {InformType} from '../../../../global/util/enum/InformType';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';

@Component({
  selector: 'app-delete-enterprise',
  templateUrl: './delete-enterprise.component.html',
  styleUrls: ['./delete-enterprise.component.css']
})
export class DeleteEnterpriseComponent {
  public enterprise: Enterprise;
  public loading: boolean;

  constructor(private activeModal: NgbActiveModal,
              private enterpriseService: EnterpriseService) {
  }

  public yes() {
    this.loading = true;
    const enterpriseId = this.enterprise.id;
    this.enterpriseService.delete(enterpriseId).subscribe(enterprise => {
      LocalStorage.updateEmbeddedValuesBy(enterprise, 'enterprises', Constant.DELETE);
      this.loading = false;
      this.activeModal.close({informType: InformType.Success, enterprise1: enterprise});
    }, error => {
      this.loading = false;
      if (HttpStatusCode.FAILED_DEPENDENCY === error.status) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });

  }

  public no() {
    this.activeModal.close(DeleteEnterpriseComponent);
  }
}
